var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77382 7.24101L5.53041 10.3085C5.87866 10.3085 6.02947 10.1745 6.21036 10.0135L7.84307 8.61545L11.2262 10.8353C11.8468 11.1452 12.2839 10.982 12.4512 10.3239L14.6719 1.00057C14.8688 0.178758 14.3409 -0.143154 13.7363 0.0584526L0.683122 4.53607C-0.207737 4.84589 -0.194249 5.29086 0.531681 5.49246L3.86887 6.42249L11.6205 2.07671C11.9853 1.86027 12.3169 1.98003 12.0441 2.19647L5.77382 7.24101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramI);
export default __webpack_public_path__ + "static/media/telegram-i.6cbf46a4a6d88bcff2a2de63cf92acec.svg";
export { ForwardRef as ReactComponent };